import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import { cartApi } from '@reducers/order/order';

export const EmptyBasketModal = () => {
  const [show, setShow] = useState(false);
  const [trigger] = cartApi.useDeleteCartContentMutation();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Button size="sm" variant="didxl" onClick={handleShow}>
        Empty basket
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Shopping cart</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure to empty the basket?</Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="didxl" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            size="sm"
            variant="didxl"
            onClick={() => {
              trigger()
                .unwrap()
                .then(() => {
                  handleClose();
                });
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
